import React, { lazy } from 'react';

import { LoginPage } from '@/modern/auth/LoginPage';

const lazyAuthPage = (load, name) => lazy(() => load().then((module) => ({ default: module[name] })));

const ResetPasswordPage = lazyAuthPage(() => import('@/modern/auth/pages/ResetPasswordPage'), 'ResetPasswordPage');
const AcceptWorkspacePage = lazyAuthPage(() => import('@/modern/auth/pages/AcceptWorkspacePage'), 'AcceptWorkspacePage');
const TokenExpiredPage = lazyAuthPage(() => import('@/modern/auth/pages/TokenExpiredPage'), 'TokenExpiredPage');
const ActivateUserPage = lazyAuthPage(() => import('@/modern/auth/pages/ActivateUserPage'), 'ActivateUserPage');
const AcceptInvitePage = lazyAuthPage(() => import('@/modern/auth/pages/AcceptInvitePage'), 'AcceptInvitePage');

export const PUBLIC_ROUTES = [
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/reset-password/:token',
    element: <ResetPasswordPage />,
    exact: true,
  },
  {
    path: '/accept-workspace/:token',
    element: <AcceptWorkspacePage />,
  },
  {
    path: '/token-expired',
    element: <TokenExpiredPage />,
  },
  {
    path: '/activate-user/:token',
    element: <ActivateUserPage />,
    exact: true,
  },
  {
    path: '/activate-new-user/:token',
    element: <AcceptInvitePage />,
    exact: true,
  },
];
